import 'whatwg-fetch';
import cookie from 'react-cookie';
import Zergling from '../helpers/zergling';
import Config from "../config/main";
import Helpers from "../helpers/helperFunctions";
import Translator from "../helpers/translator";
import CommonTranslator from "@common/helpers/translator";
import {persistStore} from 'redux-persist';
import {Connected, Disconnected, SessionLost, SessionActive} from '../actions/swarm';
import {SetLanguage, SetTerminalAuthData, ChangeSportsbookLayout, SetTerminalBalance, SetBalance, SetBonuses, getBoostedOddsIds} from "../actions/terminal";
import {ReallyLoggedIn, LoggedIn, LoggedOut, LoginStart} from '../actions/login';
import {PreferencesSet, AppReady} from '../actions';
import countries from "../constants/countries";
import {updateTranslations} from "../constants/errorCodes";
import {LoadVideoIds} from "../actions/initialData";
import setupTerminalFunctionalities from "../helpers/terminalSpecific";
import depositTerminalspecific from '../../dev/helpers/depositTerminalSpecific';
import { browserHistory } from "react-router";

let setupTerminalParams = async (store) => {
        let pid = Helpers.getUriParam("pid"),
            tid = Helpers.getUriParam("tid"),
            token = Helpers.getUriParam("token"),
            currency = Helpers.getUriParam("currency"),
            version = Helpers.getUriParam("version"),
            dualscreen = Helpers.getUriParam("dualscreen"),
            skinType = Helpers.getUriParam("skin"),
            betshopid = Helpers.getUriParam("betshopid");
        token = token && token.replace(' ', '+'); //todo delete after Khikar makes release
        if (token || pid || tid || currency || skinType || betshopid) {
            sessionStorage.setItem("authData", JSON.stringify({pid, tid, token, currency, skinType, betshopid}));
        } else {
            let authData = JSON.parse(sessionStorage.getItem("authData"));
            if (!authData || !Object.keys(authData).length) {
                sessionStorage.setItem("authData", JSON.stringify(Config.defaultTerminalParams));
            }
        }
        dualscreen !== undefined && sessionStorage.setItem("dualscreen", dualscreen);
        version !== undefined && sessionStorage.setItem("version", JSON.stringify({version}));

        if (!_.isEmpty(Config.main.blockedProviders)) {
            const country = await fetch('https://ipapi.co/json').then(res => res.json())
            localStorage.setItem('countryCode', country?.country_code)
        }

        let authData = JSON.parse(sessionStorage.getItem("authData"));
        store.dispatch(SetTerminalAuthData({"authData": authData}));
    },
    getTerminalBalance = (store) => {
        return new Promise(function (resolve) {
            let token = JSON.parse(sessionStorage.getItem("authData")).token;
            return Zergling.get({token}, "get_terminal_balance").then((response) => {
                if (response.status_code === 0) {
                    store.dispatch(SetTerminalBalance(response.data));
                    store.dispatch(SetBalance(response.data.session_balance));
                    sessionStorage.setItem("balance", JSON.stringify(response.data));
                }
                resolve();
            });
        });
    },

    Bootstrap = (store) => Promise.all([setupTerminalParams(store), Config.terminal.depositView ? depositTerminalspecific(store) : setupTerminalFunctionalities(store)]).catch().then(() => {
        if (Config.terminal.depositView) {
            return loadConfig(store).then(() => {
                return loadTranslations(store).then(() => {
                    updateTranslations();
                    store.dispatch(AppReady());
                    window.appReady = store.getState().appReady;
                    browserHistory.push("/");
                });
            });
        }
        return loadConfig(store).then(() => {
            return setSportsbookLayout(store).then(() => {
                return loadTranslations(store).then(() => {
                    updateTranslations();
                    let callback = () => {
                        getTerminalBalance(store).then(() => store.dispatch(AppReady()));
                        window.appReady = store.getState().appReady;
                        window.jsobject ? window.jsobject.appReady() : window.external.appReady();
                    };
                    // Load available video events from swarm
                    Helpers.CheckIfPathExists(Config, "main.video.getProviderAvailableEventsAndEnableFiltering")
                        ? store.dispatch(LoadVideoIds(callback))
                        : callback();
                });
            });
        });
    });

export default Bootstrap;

/**
 * Initialise Zergling with login state callback
 * must be called after loading/merging configs
 * @param store
 * @param clientId
 */
function initZergling (store, clientId) {
    Zergling.init(function (state) {
        if (state.connected !== undefined) {
            return store.dispatch(state.connected ? Connected(state) : Disconnected(state));
        }
        if (state.hasSession !== undefined) {
            return store.dispatch(state.hasSession ? SessionActive(state) : SessionLost(state));
        }
        if (state.reallyLoggedIn !== undefined) { // the real state(not the one shown in ui)
            store.dispatch(ReallyLoggedIn(state.reallyLoggedIn === Zergling.loginStates.LOGGED_IN));
        }
        if (state.loggedIn !== undefined) {
            let action = {
                [Zergling.loginStates.LOGGED_IN]: LoggedIn,
                [Zergling.loginStates.LOGGED_OUT]: LoggedOut,
                [Zergling.loginStates.IN_PROGRESS]: LoginStart
            }[state.loggedIn];
            return store.dispatch(action(state));
        }
    }, clientId);
}
/**
 * Load translations
 * @returns {Promise}
 */
function loadTranslations (store) {
    return new Promise(function (resolve) {
        let prefix = Config.translations || /languages/,
            preferences = store.getState().preferences,
            countryCode = countries.iso2ToIso3[preferences.geoData && preferences.geoData.countryCode],
            isLanguageAvailable = Config.main.availableLanguages.hasOwnProperty(countryCode),
            noTransKey = Helpers.getQueryStringValue('?notrans') === "id",
            notrans = Helpers.getQueryStringValue('notrans') !== null,
            lang = noTransKey ? "notrans" : (preferences.lang || (preferences.geoData && isLanguageAvailable && countryCode.toLowerCase()) || Config.env.lang);

        Translator.setLanguage(lang);
        CommonTranslator.setLanguage(lang); //TODO: Temprary, save just CommonTranslator after replace in App
        store.dispatch(PreferencesSet("lang", lang));
        !notrans || noTransKey
            ? fetch(prefix + `${lang}.json?v=${Date.now()}`).then(response => response.json()).then(function (json) {
                if (json[lang]) {
                    Translator.setTranslations(json[lang], lang);
                    CommonTranslator.setTranslations(json[lang], lang); 
                }
                resolve();
            }).catch(function (ex) {
                console.warn("translations not loaded", ex);
                resolve(ex);
            })
            : resolve();

    });
}

function setSportsbookLayout (store) {
    return new Promise((resolve) => {
        let asianData = sessionStorage.getItem("asianData");
        if (asianData) {
            let data = JSON.parse(asianData);
            store.dispatch(ChangeSportsbookLayout(data.asian));
            resolve();
        } else {
            store.dispatch(ChangeSportsbookLayout(Config.terminal.asianViewEnabled));
            resolve();
        }
    });
}

/**
 *  - Loads stored staloadConfige from local config and puts into store
 *  - Loads config froloadConfig external file
 *  - Merges external config with Config object
 *  - Merges saved preferences from store with ones defined in config
 * @param store
 * @returns {Promise}
 */
function loadConfig (store) {
    let notrans = Helpers.getQueryStringValue('?notrans') === "id",
        allDone,
        persistentStoreKeys = ['persistentUIState', 'preferences', 'favorites', 'betslip'],
        options = {
            whitelist: persistentStoreKeys
        },
        storeLoaded = new Promise((resolve) => persistStore(store, (() => {
            return options;
        })(), resolve)),
        configLoaded;

    // load external config and merge with Config
    configLoaded = new Promise(function (resolve) {
        if (Config.main.disableRemoteConfig) {
            resolve();
        } else {
            let configUrl = location.hostname === "localhost" ? "/conf.local.json" : "/conf.json";
            fetch(configUrl).then(response => response.json()).then(function (json) {
                Helpers.mergeRecursive(Config, json);
                console.log("Merged config:", Config);
                resolve();
            }).catch(function (ex) {
                console.warn("external config not loaded", ex, ", proceeding with default one");
                resolve(ex);
            });
        }
    });

    Promise.all([storeLoaded, configLoaded]).then(function () {
        //now we have our final config, we can initialize Zergling (Zergling uses some config values)
        initZergling(store, cookie.load('afec'));
        // Merge saved preferences from state with Config.env
        let state = store.getState(),
            defaultLanguage = state.preferences.lang ? state.preferences.lang : Config.env.lang,
            init = {
                ...state.preferences,
                lang: defaultLanguage
            };
        defaultLanguage = Config.swarm.languageMap[defaultLanguage] || defaultLanguage;
        store.dispatch(SetLanguage(defaultLanguage));
        Config.betting.enableExpressBonus && Zergling.get({}, 'get_sport_bonus_rules').then(response => store.dispatch(SetBonuses(response.details)));
        if (state && state.preferences) {
            Helpers.mergeRecursive(Config.env, init);
        }
        if (Config.enableBoostedOdds) {
            Zergling.get({}, "get_boosted_selections").then((resp) => store.dispatch(getBoostedOddsIds(resp.details)));
        }
        // Save Config.env to store
        Object.keys(Config.env).map(k => {
            store.dispatch(PreferencesSet(k, Config.env[k]));
        });

        console.log("store:", state, "config:", Config);
        allDone(notrans);
    });

    return new Promise(resolve => {
        allDone = resolve;
    });
}